module.exports = __webpack_public_path__ + "static/media/instagram.995545bb.svg";